import { get } from '@core/api/baseApi';

export const getStudyTokenWithoutOrgSecurity = async ({
  studyHash,
}: {
  studyHash: string;
}): Promise<{ token: string }> => {
  return await get(`/studies/shared/${studyHash}/token`);
};
